import { Grid } from "@mui/material";
import styled from "styled-components";
import { ImageElement } from "components/Image/Image.styled";

export const SubSectionContainer = styled(Grid)`
  text-align: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 80px;
  margin-top: ${(props) =>
    props?.marginTop !== undefined && props.marginTop !== ""
      ? props.marginTop
      : "12px"};
  margin-bottom: 98px;
  &:last-of-type {
    margin-bottom: 65px;
  }
  @media (max-width: 1126px) {
    flex-direction: ${(props) =>
      props.$reverse ? "column-reverse" : "column"};
  }
  @media (max-width: 768px) {
    gap: 24px;
    margin-bottom: 5px;
    &:last-of-type {
      margin-bottom: 5px;
    }
  }
`;
export const SubSectionContainerText = styled.div`
  text-align: left;
  height: 100%;
  font-size: 24px;
  line-height: 36px;
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  color: ${(props) => props?.$textColor};
  @media (max-width: 900px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    line-height: 150%;
    margin-bottom: 64px;
    flex: none;
    width: 100%;
    max-width: 100%;
    white-space: normal;
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
`;
export const InnerSubSection = styled.div`
  display: flex;
  flex-direction: row;
  &:has(img) {
    flex-shrink: 0;
  }
  &:not(:has(img)) {
    flex: 1;
    min-width: 0;
  }
  & img {
    max-height: ${(props) =>
      props.height !== undefined && props.height !== ""
        ? props.height
        : "420px"};
    max-width: ${(props) =>
      props.height === undefined && props.height === "" ? "auto" : "550px"};
  }
  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    min-width: 0;
    & img {
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      max-height: none !important;
      object-fit: cover;
    }
    & ${ImageElement} {
      height: auto !important;
      width: 100% !important;
      max-width: 100% !important;
      max-height: none !important;
      object-fit: cover;
    }
  }
`;
